import { z } from "zod";

import { nullToUndefined } from "api/utils";

const publicationTypeEnumSchema = z.enum([
  "Blogs and Articles",
  "Data Visualizations",
  "Reports and Policy Briefs",
  "Industry Analysis",
  "Case Studies and Capacity Building",
  "Guides, Playbooks and Recommendations",
  "Databases",
  "Assessment Tools and Dashboards",
  "Expert Analysis",
]);

const autoApprovedEnumSchema = z.enum(["Full", "Conservative"]);

export const sourceDetailSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: nullToUndefined(z.string()),
  active: nullToUndefined(z.boolean()),
  description: nullToUndefined(z.string()),
  content_type: nullToUndefined(z.string()),
  // NOTE: Handling `null` here to associate `null` with the correct labels inside AUTOPILOT_OPTIONS in `/moderate/sources/constants.ts`
  publication_type: publicationTypeEnumSchema,
  auto_approved: autoApprovedEnumSchema.nullable(),
  favicon: nullToUndefined(z.string()),
  preserve_article_links: nullToUndefined(z.boolean()),
  type: nullToUndefined(z.string()),
  last_started_update: nullToUndefined(z.number()),
  license: nullToUndefined(z.string()),
  display_name: z.string(),
  region: nullToUndefined(z.string()),
  country: nullToUndefined(z.string()),
  greater_region: nullToUndefined(z.string()),
});

export const getSourcesSchema = z.array(sourceDetailSchema);

export type SourceDetail = z.infer<typeof sourceDetailSchema>;
